import { HttpClient } from '@angular/common/http';
import { LeaderboardPublicPort } from '../../../domain/leaderboard/ports/leaderboard-public.port';
import { LeaderboardPublicHttpAdapter } from '../adapters/leaderboard-public-http.adapter';
import { LeaderboardPublicStubAdapter } from '../adapters/leaderboard-public-stub.adapter';
import { ENVIRONMENT } from '../../../../environments/environment';

export function leaderboardPublicPortFactory(http: HttpClient): LeaderboardPublicPort {
  const useHttp = !ENVIRONMENT.mockEnabled && Boolean(ENVIRONMENT.leaderboardEventsApiUrl?.trim());
  return useHttp ? new LeaderboardPublicHttpAdapter(http) : new LeaderboardPublicStubAdapter();
}
